import { useEffect, useState } from "react";

const MOBILE_BREAKPOINT = 1024;

const checkIsMobile = () => {
    const isSmallScreen = window.innerWidth <= MOBILE_BREAKPOINT;
    const isTouchDevice = "ontouchstart" in window || navigator.maxTouchPoints > 0;
    return isSmallScreen && isTouchDevice;
};

export const useIsMobile = () => {
    const [isMobile, setIsMobile] = useState<boolean>(checkIsMobile());

    useEffect(() => {
        const handleResize = () => setIsMobile(checkIsMobile());
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return isMobile;
};